import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'dmp-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {
  message: string;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  display: boolean = false;

  constructor() {}

  showDialog() {
    this.display = true;
  }

  closeDialog() {
    this.display = false;
  }

  onConfirm() {
    this.confirm.emit();
    this.closeDialog();
  }

  onCancel() {
    this.cancel.emit();
    this.closeDialog();
  }
}